import { Element } from "@xmpp/xml"
import { jid } from "@xmpp/client"
import { DataFormsParser } from "./formParser"

type ShareRoute = {
  type: "result" | "error"
  from: ReturnType<typeof jid.parse>
  to: ReturnType<typeof jid.parse>
  id: string
  node: string
  sessionId: string
  status: string
  secret: string
}

export default class ShareRouteParser {
  static parse(stanza: Element): ShareRoute | undefined {
    if (
      stanza.name !== "iq" ||
      !stanza.getAttr("from") ||
      !stanza.getAttr("to")
    )
      return

    const from = jid.parse(stanza.getAttr("from"))
    const to = jid.parse(stanza.getAttr("to"))
    const type = stanza.getAttr("type")
    const id = stanza.getAttr("id")

    const command = stanza.getChild(
      "command",
      "http://jabber.org/protocol/commands",
    )
    if (!command) return

    const node = command.getAttr("node")
    const sessionId = command.getAttr("sessionid")
    const status = command.getAttr("status")

    const form = command && DataFormsParser.parse(command)

    const secret = form?.fields?.["secret"].values[0] || ""

    return {
      type: type as "result" | "error",
      from,
      to,
      id,
      node,
      sessionId,
      status,
      secret,
    }
  }
}
